import main from '@/main';
import { PackageType } from '@/utils/dict';
import dayjs from 'dayjs';
import RadioBox from '../radioBox';
interface Props {
  order: OrderInfo;
  emPack: EmPack;
  price: number;
  selectEquity: string[];
  benefitList?: any;
  selectedBenefitId?: string;
  onBuy: (v?: any) => void;
}
// , onBenefitChange
export default function PayOrderCard({ order, price, emPack, selectEquity, onBuy }: Props) {
  // 权益包信息
  const equityPackJsonList = order?.cardProductActivityEquityPackJsonList || [];
  let packJsonList = equityPackJsonList.filter((i) => selectEquity.includes(i.equityPackageInfoId!));
  return (
    <div className="pay-order-wrap">
      <div
        className="mask-block"
        onClick={(e) => {
          e.stopPropagation();
          onBuy(false);
        }}
      ></div>
      <div className="base-order">
        <div className="order-title bg-p p-15 text-center font-widget-600 font-size-16">
          设备号：{main.currentEm?.emNumber}
        </div>
        {/* 顶部基础订单信息 */}
        <div className="p-10" style={{ maxHeight: '65vh', overflowY: 'auto' }}>
          <div className="item-line p-15 bg-gray">
            <div className="d-flex-r ai-center jc-between font-size-14 line-height-24">
              <div className="text-color-3">本次消费支付：</div>
              <div className="text-color-3">{price}元</div>
            </div>
            <div className="d-flex-r ai-center jc-between font-size-14 line-height-24">
              <div className="text-color-3">订单名称：</div>
              <div className="text-color-3">{order?.name}</div>
            </div>
            <div className="d-flex-r ai-center jc-between font-size-14 line-height-24">
              <div className="text-color-3">订单类型：</div>
              <div className="text-color-3">{emPack.packageType === PackageType.basicpackage ? '基础包' : '加油包'}</div>
            </div>
            <div className="d-flex-r ai-center jc-between font-size-14 line-height-24">
              <div className="text-color-3">套餐消费：</div>
              <div className="text-color-3">{order?.realPrice}元</div>
            </div>
            <div className="d-flex-r ai-center jc-between font-size-14 line-height-24">
              <div className="text-color-3">套餐有效期：</div>
              <div className="text-color-3">
                {dayjs(order?.startEffectTime).format('YYYY-MM-DD')}至{dayjs(order?.endEffectTime).format('YYYY-MM-DD')}
              </div>
            </div>
          </div>
          {/* 权益包信息 onClick={onBenefitChange} */}
          <div className="bg-gray mt-10 p-10 pl-10 pr-10 border-radius-12">
            <div className="text-color-p">权益包</div>
            {
              packJsonList.map((item) => (
                <div className="d-flex-r mt-10">
                  <div
                    className="flex-1 d-flex-r p-5 border border border-radius-12 bg-white">
                    <img className="w-80 h-80 mr-10 border-radius-8" src={item?.img} alt="" />
                    <div className="package-info flex-1 d-flex-c jc-between pt-5 pb-5 minh-80">
                      <span className="font-widget-600">
                        {item.activityDetailName}
                      </span>
                      <span className="omit-text-3">{item.tips}</span>
                      <span className="text-gold-color">¥{item.price}</span>
                    </div>
                  </div>
                  {/* <RadioBox value={selectEquity} onChange={onBenefitChange} /> */}
                </div>
              ))
            }
          </div>
        </div>
        <div className="d-flex-r ai-center jc-between pl-10 pr-10 pb-20">
          <div className="d-flex-r ai-end">
            合计：
            <span className="text-color-p mr-3">¥</span>
            <span className="text-color-p font-size-20">{price}</span>
          </div>
          <div className="bg-p border-radius-20 text-white-color p-10 pl-20 pr-20" onClick={() => onBuy(true)}>
            立即购买
          </div>
        </div>
      </div>
    </div>
  );
}
